const deviceTypeColors = {
  DEV_TYPE_UNKNOWN: "#FFFFFF",
  DEV_TYPE_V24_CHARGER: "#FC8C56",
  DEV_TYPE_V24_HOLDER: "#FB5607",
  DEV_TYPE_V24P_CHARGER: "#FF006E",
  DEV_TYPE_V24P_HOLDER: "#AD004B",
  DEV_TYPE_P1V30_CHARGER: "#01A7C2",
  DEV_TYPE_P1V30_HOLDER: "#007090",
  DEV_TYPE_P1V30M: "#3A86FF",
  DEV_TYPE_P1V31_CHARGER: "#9CA3E6",
  DEV_TYPE_P1V31_HOLDER: "#404FCF",
  DEV_TYPE_P4_M3_G1: "#606060",
  DEV_TYPE_P4_M3_G2: "#606060",
  DEV_TYPE_P1V40V_CHARGER: "#F7B04D",
  DEV_TYPE_P1V40V_HOLDER_CONTROL: "#B78239",
  DEV_TYPE_P1V40C_CHARGER: "#2BBA99",
  DEV_TYPE_P1V40C_HOLDER_CONTROL: "#1D7F68",
  DEV_TYPE_P1V40D_CONTROL: "#F45B69",
  DEV_TYPE_P1V31M: "#E072A4",
  DEV_TYPE_P1_ARIANE: "#748CAB"
};

export default deviceTypeColors;
